<odx-modal-header>
  <odx-area-header>{{ headerText }}</odx-area-header>
</odx-modal-header>
<odx-modal-content>
  <p>{{ text }}</p>
</odx-modal-content>
<odx-modal-footer [class.stacked-confirm-footer]="isMobileConfirmModal">
  <button
    odxButton
    variant="secondary"
    odxModalDismiss
    class="confirm-modal-dismiss-button secondary-button"
    [class.stacked-confirm-footer__button]="isMobileConfirmModal"
    i18n="@@global.dismiss"
  >
    Abbrechen
  </button>
  @if (discardButtonText) {
    <button odxButton variant="secondary" (click)="onDiscard()" class="confirm-modal-discard-button">
      {{ discardButtonText }}
    </button>
  }
  <button
    odxButton
    variant="primary"
    class="confirm-modal-confirm-button primary-button"
    [class.stacked-confirm-footer__button]="isMobileConfirmModal"
    (click)="onConfirm()"
  >
    {{ confirmButtonText }}
  </button>
</odx-modal-footer>
